import TabButton from 'components/Button/TabButton/TabButton';
import React from 'react';
import { SynchrotronTripTab } from './constants';

interface TabRendererProps {
  key?: number;
  iconName: any;
  id?: number;
  onTabClick: any;
  activeTab: any;
  currentTab: SynchrotronTripTab;
  tooltip: string;
}

interface SidebarOptionsProps {
  onTabClick: any;
  activeTab: any;
}

const TabRenderer = (props: TabRendererProps) => {
  const { iconName, onTabClick, activeTab, currentTab, tooltip } = props;
  return (
    <div id="synchrotron-tabrenderer-tab-button" onClick={() => onTabClick(currentTab)}>
      <TabButton
        IconProps={{ name: iconName }}
        active={activeTab == currentTab}
        titleTip={tooltip}
      />
    </div>
  );
};
export const SideBarOptions = ({ onTabClick, activeTab }: SidebarOptionsProps) => {
  const tabs = [
    {
      iconName: 'SynchTrip',
      id: SynchrotronTripTab.Info,
      tooltip: 'Synchrotron Trip Info',
    },
    {
      iconName: 'SynchTripResult',
      id: SynchrotronTripTab.CrystalResults,
      tooltip: 'Synchrotron Trip Results',
    },
    {
      iconName: 'SynchTripCrystals',
      id: SynchrotronTripTab.UnassignedCrystals,
      tooltip: 'Unassigned Crystals',
    },
  ];

  const options = tabs.map((tab, index) => {
    return (
      <TabRenderer
        key={index}
        iconName={tab.iconName}
        id={tab.id}
        onTabClick={onTabClick}
        activeTab={activeTab}
        currentTab={tab.id}
        tooltip={tab.tooltip}
      />
    );
  });
  return <>{options}</>;
};
